import { PageCondition } from "./conditions";
import ACTIONS from "./actions";
import goto from "./goto";

export enum Direction {
  FORWARD = "FORWARD",
  BACKWARD = "BACKWARD",
  CURRENT = "CURRENT",
}

export type PageList = (Block | Page | SwitchCondition)[];

export interface PageSet {
  id: string;
  description?: string;
  pages: PageList;
  context_type: string;
  conditions?: PageCondition[];
}

/** @notExported */
type InheritablePageParams = {
  conditions?: PageCondition[];
  actions?: Action[];

  props?: PropertyBag & {
    /**
     * Numeric index of the progress bar this component is part of, if displayed.
     *
     * - 1 | 2 | 3 -> Progress bar section
     * - false -> No progress bar
     */
    progressBar?: number | false;
  };
};

/** @notExported */
type GoToActions = {
  [name in keyof typeof goto]?: Parameters<typeof goto[name]>;
};

export type Block = {
  name?: string;
  block: (Page | SwitchCondition)[];
  onComplete?: Action[];
} & InheritablePageParams;

export type Page = {
  pathname?: string;
  goto?: GoToActions;
} & InheritablePageParams;

export type SwitchCondition = {
  switch: string;
  cases: {
    [key: string]: Page;
    default?: Page;
  };
} & InheritablePageParams;

export interface Action {
  type: keyof typeof ACTIONS;
  params?: PropertyBag;
}
